import React, { useState } from 'react'

import styled from 'styled-components'

import { toggleElementById } from '../../../../utils/toggleElement'
import {
  AllFilterButton,
  FilterTitle,
  FlexColumn,
  FlexRow,
  FlexRowBetween,
} from '../../../projectComponents'
import { ColorButton } from '../../ColorButton'
import { ColorCriteriaModal } from './ColorCriteriaModal'

interface SelectColorComponentProps {
  compact?: boolean
  colorIds: number[]
  colors: string[]
  labels?: string[]
  setColorIds: any
  title?: string
}

const Wrapper = styled(FlexColumn)`
  width: 100%;
`
const OverflowWrapper = styled(FlexRow)`
  width: 100%;
  justify-content: flex-start;
`
const ColorsWrapper = styled(FlexRow)`
  gap: 10px 5px;
  flex-wrap: wrap;
  justify-content: start;
  margin-top: 12px;
  width: 100%;
`

export const SelectColorComponent: React.FC<SelectColorComponentProps> = ({
  compact,
  colorIds,
  colors,
  labels,
  setColorIds,
  title = 'Цвет',
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false)
  const clickOnColor = id => toggleElementById(id, colorIds, setColorIds)
  const visibleColors = colors.slice(0, compact ? 6 : colors.length)

  return (
    <Wrapper>
      <FlexRowBetween>
        <FilterTitle
          as={compact ? 'h3' : 'h2'}
          style={compact ? { fontSize: 16, lineHeight: '24px' } : undefined}
        >
          {title}
        </FilterTitle>
        <AllFilterButton type="button" onClick={() => setIsModalOpen(true)}>
          Все
        </AllFilterButton>
      </FlexRowBetween>
      <OverflowWrapper>
        <ColorsWrapper>
          {visibleColors.map((color, id) => (
            <ColorButton
              clickOnColor={clickOnColor}
              color={color}
              id={id}
              key={id}
              label={labels?.[id]}
              selected={colorIds.includes(id)}
            />
          ))}
        </ColorsWrapper>
      </OverflowWrapper>
      <ColorCriteriaModal
        colors={colors}
        labels={labels}
        selectedIds={colorIds}
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        onApply={setColorIds}
        title={title}
      />
    </Wrapper>
  )
}
